import { render } from "./WidgetsPage.vue?vue&type=template&id=0a2d105c&ts=true"
import script from "./WidgetsPage.vue?vue&type=script&lang=ts"
export * from "./WidgetsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__